import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import Success from './Success'
import Failed from './Failed'
import Activate from './Activate'
import TrueNorthServer from './TrueNorthServer'
import TrueNorthGarmin from './TrueNorthGarmin'
import TrueNorthDownload from './TrueNorthDownloads'
import TrueNorthContacts from './TrueNorthContacts'
import TrueNorthSALogin from './SALogin'
import TrueNorthSAHome from './TrueNorthSAHome'
import TrueNorthSASail from './TrueNorthSASail'
//import Test from './Test'
import * as serviceWorker from './serviceWorker';
import Firebase, { FirebaseContext } from './components/Firebase';

//<div style={{background: 'linear-gradient(158deg, rgb(33, 25, 111) 0%, rgb(59, 185, 175) 100%)'}}>

const routing = (
    <Router>
      <div style={{backgroundColor:'#d4d4d4'}}>
      <Route exact path="/" component={App} />
      <Route exact path="/Success" component={Success} />
      <Route exact path="/Failed" component={Failed} />
      <Route exact path="/Activate" component={Activate} />
      <Route exact path="/TrueNorthServer" component={TrueNorthServer} />
      <Route exact path="/TrueNorthGarmin" component={TrueNorthGarmin} />
      <Route exact path="/TrueNorthSailAnalysis/Login" component={TrueNorthSALogin} />
      <Route exact path="/TrueNorthSailAnalysis/Home" component={TrueNorthSAHome} />
      <Route exact path="/TrueNorthSailAnalysis/Sail" component={TrueNorthSASail} />
      <Route exact path="/Download" component={TrueNorthDownload} />
      <Route exact path="/Contacts" component={TrueNorthContacts} />
      </div>
    </Router>
  )

ReactDOM.render(
  <FirebaseContext.Provider value={new Firebase()}>
   {routing}
  </FirebaseContext.Provider>,
  document.getElementById('root'),
);

//ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
